function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUsafe(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#040000",
    d: "M48 4.901L3.166 21.526l.979 3.54c1.5 5.425 2.244 10.159 2.963 14.738C9.321 53.887 11.07 65.01 32.065 79.462c5.72 3.937 11.05 9.299 12.802 11.061l3.106 3.106 2.828-2.773c1.935-1.896 7.15-6.795 13.789-11.294 18.745-12.698 26.991-53.066 27.333-54.778l.668-3.347L48 4.901zM15.011 38.562c-.57-3.627-1.2-7.637-2.244-12.063l31.713-11.76v64.383c-2.308-2.048-5.031-4.29-7.879-6.25-18.163-12.502-19.526-21.178-21.59-34.31zm63.005 5.723C72.793 58.63 66.599 68.538 60.103 72.938a105.533 105.533 0 00-7.622 5.711V15.095l30.85 11.44c-.916 3.818-2.676 10.501-5.315 17.75z"
  }));
}

SvgUsafe.clsName = 'icon-www__usafe';
SvgUsafe.remarkName = 'unknown';
export default SvgUsafe;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Usafe.js
// module id = 2519
// module chunks = 17 18